export type AppStatus = "ready" | "external" | "planned";

export const OMNIKPI_EXTERNAL_URL = "https://omnikpi.duckdns.org";

export interface OmniApp {
  key: string;
  index: string;
  name: string;
  shortName: string;
  description: string;
  category: "Control" | "Data" | "Operations" | "Engineering";
  status: AppStatus;
  badge?: string;
  capability?: string;
  routeName?: string;
  externalUrl?: string;
  confirmBeforeOpen?: boolean;
}

export const appRegistry: readonly OmniApp[] = [
  {
    key: "upload",
    index: "01",
    name: "Omni Upload",
    shortName: "Upload",
    description:
      "Détection, mapping et import contrôlé vers OmniKPI avec preuve de catalogue.",
    category: "Data",
    status: "ready",
    capability: "artifact.upload",
    routeName: "uploads",
    badge: "NEW",
  },
  {
    key: "kpi-monitoring",
    index: "02",
    name: "KPI Monitoring",
    shortName: "OmniKPI",
    description:
      "Faits radio, séries temporelles, qualité réseau et dashboards.",
    category: "Operations",
    status: "external",
    externalUrl: OMNIKPI_EXTERNAL_URL,
    confirmBeforeOpen: true,
  },
  {
    key: "inventory",
    index: "03",
    name: "Network Inventory",
    shortName: "Inventory",
    description: "Sites, cellules, objets réseau et données de référence.",
    category: "Operations",
    status: "ready",
    capability: "inventory.read",
    routeName: "inventory",
  },
  {
    key: "parameter-audit",
    index: "04",
    name: "Parameter Audit",
    shortName: "Audit",
    description:
      "Comparaison de paramètres réseau contre les références publiées.",
    category: "Engineering",
    status: "planned",
  },
  {
    key: "capacity",
    index: "05",
    name: "Capacity Analysis",
    shortName: "Capacity",
    description: "Analyses de charge et capacité multi-technologies.",
    category: "Engineering",
    status: "planned",
  },
  {
    key: "gis",
    index: "06",
    name: "GIS & Maps",
    shortName: "Maps",
    description: "Cartographie des sites, secteurs et zones d'analyse.",
    category: "Operations",
    status: "planned",
  },
  {
    key: "catalogs",
    index: "07",
    name: "Catalogs & Rules",
    shortName: "Catalogs",
    description: "KPI, paramètres, seuils, règles et publications versionnées.",
    category: "Control",
    status: "ready",
    routeName: "catalogs",
  },
  {
    key: "incidents",
    index: "09",
    name: "Incidents & Alerts",
    shortName: "Incidents",
    description: "Incidents réseau, alertes et notifications centralisées.",
    category: "Operations",
    status: "planned",
  },
  {
    key: "operations",
    index: "10",
    name: "Network Toolbox",
    shortName: "Toolbox",
    description:
      "Menu clair des outils réseau migrés depuis les apps Streamlit.",
    category: "Engineering",
    status: "ready",
    routeName: "operations",
  },
] as const;
